/*
* home api
* */

export const bar_url = "https://www.easy-mock.com/mock/5ccee7ded9699f18dbd891c1/nayo-admin/bar";
export const stock_url = "https://www.easy-mock.com/mock/5ccee7ded9699f18dbd891c1/nayo-admin/stock";
export const weather_url = "https://www.easy-mock.com/mock/5ccee7ded9699f18dbd891c1/nayo-admin/weather";
export const circle_url = "https://www.easy-mock.com/mock/5ccee7ded9699f18dbd891c1/nayo-admin/circle";